import type { CSSObject } from '@emotion/react';

export const threadDrawerStyles: CSSObject = {
  borderTop: '1px solid var(--fabric-color-neutral-20)',
  overflowY: 'hidden',
};

export const groupContentStyles: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

export const groupIdentityHeaderStyles: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 'var(--fabric-number-n-2-px)',
  padding: 'var(--fabric-number-n-3-px) var(--fabric-number-n-2-px) var(--fabric-number-n-3-px)',
  minWidth: 0,
};

export const groupContactsButtonStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'var(--fabric-number-n-0-5-px)',
  padding: 'var(--fabric-number-n-1-px)',
  borderRadius: 'var(--fabric-radius-sm)',
  ':hover, :focus': {
    backgroundColor: 'var(--fabric-color-neutral-10)',
  },
};

export const groupTitleWrapperStyles: CSSObject = {
  width: '100%',
  minWidth: 0,
  overflow: 'hidden',
  gap: 'var(--fabric-number-n-0-5-px)',
  '[data-trackingid="group-thread-title-edit-button"]': {
    justifyContent: 'center',
  },
  '[data-trackingid="group-thread-title-edit-button"] > span': {
    minWidth: 0,
    overflow: 'hidden',
  },
  '> div': {
    justifyContent: 'center',
  },
};

export const rowLabelStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'var(--fabric-number-n-1-px)',
};

export const groupLocationRowStyles: CSSObject = {
  padding: 'var(--fabric-number-n-0-5-px) var(--fabric-number-n-2-px)',
  borderBottom: '1px solid var(--fabric-color-neutral-20)',
  ':empty': {
    padding: 0,
    borderBottom: 'none',
  },
};

export const groupLocationPhoneSelectorStyles: CSSObject = {
  justifyContent: 'start',
  padding: 'var(--fabric-number-n-0-5-px) 0',
};

export const personPhoneSelectorBaseStyles: CSSObject = {
  justifyContent: 'start',
  borderBottom: '1px solid var(--fabric-color-neutral-20)',
};

export const personPhoneSelectorMultiOptionPaddingStyles: CSSObject = {
  padding: 'var(--fabric-number-n-0-5-px) var(--fabric-number-n-2-px)',
};

export const personPhoneSelectorSingleOptionPaddingStyles: CSSObject = {
  padding: 'var(--fabric-number-n-2-px)',
};

export const changeThreadLocationPhoneSelectorStyles: CSSObject = {
  justifyContent: 'start',
  padding: 'var(--fabric-number-n-0-5-px) var(--fabric-number-n-2-px)',
  borderBottom: '1px solid var(--fabric-color-neutral-20)',
};

export const associatedContactsHeaderStyles: CSSObject = {
  padding: 'var(--fabric-number-n-2-px)',
  borderBottom: '1px solid var(--fabric-color-neutral-10)',
  width: '100%',
};

export const associatedContactsHeaderRowStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const associatedContactsBackButtonStyles: CSSObject = {
  width: 'var(--fabric-number-n-6-px)',
  height: 'var(--fabric-number-n-6-px)',
  padding: 'var(--fabric-number-n-1-px)',
};

export const associatedContactsCountStyles: CSSObject = {
  width: 'var(--fabric-number-n-4-px)',
  height: 'var(--fabric-number-n-4-px)',
};

export const fullWidthTextStyles: CSSObject = {
  width: '100%',
};

export const associatedContactsListStyles: CSSObject = {
  width: '100%',
  listStyle: 'none',
  margin: 0,
  paddingInlineStart: 0,
  maxHeight: '25vh',
  overflowY: 'auto',
};

export const buttonStyles: CSSObject = {
  width: '100%',
  borderBottom: '1px solid var(--fabric-color-neutral-20)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 'var(--fabric-number-n-2-px)',
  transition: 'background-color 200ms ease-in-out',
  ':hover, :focus': {
    backgroundColor: 'var(--fabric-color-neutral-5)',
    outlineColor: 'var(--fabric-color-primary-50)',
  },
  ':active': {
    backgroundColor: 'var(--fabric-color-neutral-10)',
  },
};

/** Top row for group thread drawer: back button | title | group contacts button */
export const groupTopRowStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: 'var(--fabric-number-n-1-px) var(--fabric-number-n-2-px)',
};
